import * as React from 'react';
import IThemeContext from './pageheader-theme.context.interface';

const defaultContext: IThemeContext = { theme: "dark", isInAccountSection: false, isHeaderVisible: true, isMenuVisible: true, isMiniCartDisabled: false };
const PageHeaderThemeContext = React.createContext(defaultContext);
export default PageHeaderThemeContext;